import React, { Component } from "react";
import { Row, Col, Card, Form } from "reactstrap";
import CgnTextbox from "../toolbox/CgnTextbox";
import CgnReactSelect from "../toolbox/CgnReactSelect";
import CgnAlert from "../toolbox/CgnAlert";
import CgnButtonGroup from "../toolbox/CgnButtonGroup";
import CgnLoader from "../toolbox/CgnLoader";
import CgnMessage from "../toolbox/CgnMessage";
import CgnButtonLink from "../toolbox/CgnButtonLink";
import ContentTop from "../root/ContentTop";
import axios from "axios";
import { URL, optionStatuses } from "../../redux/actions/constants";
import { withRouter } from "react-router-dom";

class CustomerEducationAddUpdate extends Component {
  state = {
    pageTitle: "Eğitim Alacak Müşteriler Ekle",
    pageTitleAdd: "Eğitim Alacak Müşteriler Ekle",
    pageTitleUpdate: "Eğitim Alacak Müşteriler Güncelle",
    pageAddLink: "musteri-egitim-ekle",
    pageListLink: "musteri-egitim-listele",
    breadcrumb: [{ text: "Eğitim Alacak Müşteriler", link: "#" }],
    isLoading: false,
    urlSplit: [],
    guid: "",
    customerGuid: "",
    customerGuidError: "",
    userName: "",
    userNameError: "",
    status: true,
    alertErrorMessage: "",
    customerArr: [],
    buttons: [
      {
        type: "button",
        color: "secondary",
        text: CgnMessage.clearButton,
        onClick: (event) => this.handleClear(event),
        disabled: this.isLoading,
      },
      {
        type: "submit",
        color: "primary",
        text: CgnMessage.saveButton,
        disabled: this.isLoading,
      },
    ],
  };

  async componentDidMount() {
    this.setState({
      isLoading: true,
    });
    // 
    var config = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    };
    await axios
      .get(URL + "/customers/getlist/2", config)
      .then((response) => {
        var myArr = response.data.map(function (item) {
          return {
            value: item.guid,
            label: item.name,
          };
        });
        this.setState({
          customerArr: myArr,
        });
      })
      .catch((error) => {
        this.setState({
          alertErrorMessage: error.response.data,
        });
      });
    let urlSplit = window.location.pathname.split("/");
    this.setState({
      urlSplit: urlSplit,
    });
    if (urlSplit.length === 3) {
      this.setState({
        guid: urlSplit[urlSplit.length - 1],
        pageTitle: this.state.pageTitleUpdate,
      });
      this.getById(urlSplit[2]);
      await axios
        .get(URL + "/customerEducation/get/" + urlSplit[2], config)
        .then((response) => {
          if (this.state.guid) {
            this.setState({
              customerGuid: response.data.customerGuid,
              userName: response.data.userName,
              status: response.data.status,
              isLoading: false,
            });
          }
        });
    } else {
      this.setState({
        isLoading: false,
      });
    }
  }

  async componentDidUpdate() {
    let urlSplit = window.location.pathname.split("/");
    if (
      urlSplit.length === 2 &&
      this.state.pageTitle !== this.state.pageTitleAdd
    ) {
      this.setState({
        pageTitle: this.state.pageTitleAdd,
        urlSplit: urlSplit,
        status: true,
      });
    }
    if (this.state.status === undefined) {
      this.setState({
        status: true,
      });
    }
  }

  getById(guid) {
    this.setState({
      isLoading: true,
      guid: guid,
    });
  }

  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState({
      [name]: value,
    });
    this.setState({
      userNameError: "",
      alertErrorMessage: "",
    });
    if (name === "userName" && value === "") {
      this.setState({
        userNameError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
  };

  handleStatusSelectChange(name, status) {
    if (status != null && status.value !== "") {
      this.setState({
        [name]: status.value,
        customerGuidError: "",
        alertErrorMessage: "",
      });
    } else {
      this.setState({
        [name]: "",
      });
      if (name === "customerGuid") {
        this.setState({
          customerGuidError: CgnMessage.textErrorMessage,
          alertErrorMessage: CgnMessage.alertErrorMessage,
        });
      }
    }
  }

  handleClear = (event) => {
    this.clearPage();
  };

  clearPage() {
    this.setState({
      customerGuid: "",
      userName: "",
      status: true,
      alertErrorMessage: CgnMessage.alertErrorMessage,
      customerGuidError: CgnMessage.textErrorMessage,
      userNameError: CgnMessage.textErrorMessage,
    });
  }

  handleSave = async (event) => {
    event.preventDefault();
    this.setState({
      customerGuidError: "",
      userNameError: "",
      alertErrorMessage: "",
    });

    if (this.state.customerGuid === "") {
      this.setState({
        customerGuidError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    } else if (this.state.userName === "") {
      this.setState({
        userNameError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    } else if (this.state.customerGuid !== "" && this.state.userName !== "") {
      this.setState({
        isLoading: true,
      });
      // 
      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      var myObj = {
        customerGuid: this.state.customerGuid,
        userName: this.state.userName,
        status: this.state.status,
      };
      var URLParam = "/customerEducation/add";
      if (this.state.guid && this.state.urlSplit.length !== 2) {
        URLParam = "/customerEducation/update";
        myObj = {
          guid: this.state.guid,
          customerGuid: this.state.customerGuid,
          userName: this.state.userName,
          status: this.state.status,
        };
      }
      axios
        .post(URL + URLParam, myObj, config)
        .then(() => {
          setTimeout(() => {
            if (this.state.guid) {
              window.location.href = "/musteri-egitim-listele";
            }
            if (this.state.urlSplit[1] === "musteri-egitim-ekle") {
              window.location.reload();
            }
          }, 1500);
        })
        .catch((error) => {
          this.setState({
            alertErrorMessage: error.response.data,
            isLoading: false,
          });
        });
    } else {
      this.setState({
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
  };

  render() {
    return (
      <>
        {(this.state.urlSplit[1] === "musteri-egitim-ekle" ||
          this.state.urlSplit[1] === "musteri-egitim-guncelle") && (
          <ContentTop
            breadcrumb={this.state.breadcrumb}
            title={this.state.pageTitle}
            addLink={"/" + this.state.pageAddLink}
            listLink={"/" + this.state.pageListLink}
          />
        )}
        <Row>
          <Col>
            <Form onSubmit={this.handleSave}>
              <Card body>
                <CgnLoader visibled={this.state.isLoading} />
                <Row>
                  <Col lg="6">
                    <CgnReactSelect
                      name="customerGuid"
                      label="Müşteri [*]"
                      isMulti={false}
                      isClearable={true}
                      selectValue={this.state.customerGuid}
                      options={this.state.customerArr}
                      onChange={(customerGuid) =>
                        this.handleStatusSelectChange(
                          "customerGuid",
                          customerGuid
                        )
                      }
                      placeholder="Lütfen müşteri seçin..."
                      error={this.state.customerGuidError}
                    />
                  </Col>
                  <Col lg="6">
                    <CgnTextbox
                      type="text"
                      name="userName"
                      label="Kullanıcı Adı [*]"
                      value={this.state.userName}
                      placeHolder="Lütfen kullanıcı adı girin..."
                      autoComplete="off"
                      maxLength="50"
                      onChange={this.handleChange}
                      error={this.state.userNameError}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col lg="3">
                    <CgnReactSelect
                      name="status"
                      label="Durumu"
                      isMulti={false}
                      selectValue={this.state.status}
                      options={optionStatuses}
                      onChange={(status) =>
                        this.handleStatusSelectChange("status", status)
                      }
                    />
                  </Col>
                  <Col lg="9"></Col>
                </Row>
                {this.state.alertErrorMessage && (
                  <CgnAlert
                    color="danger"
                    title={CgnMessage.alertErrorTitle}
                    text={this.state.alertErrorMessage}
                  />
                )}
                <CgnButtonGroup items={this.state.buttons} />
              </Card>
            </Form>
            {(this.state.urlSplit[1] === "musteri-egitim-ekle" ||
              this.state.urlSplit[1] === "musteri-egitim-guncelle") && (
              <CgnButtonLink
                color="secondary"
                to={"/" + this.state.pageListLink}
                text={CgnMessage.backButton}
                className="btn-back"
              />
            )}
          </Col>
        </Row>
      </>
    );
  }
}
export default withRouter(CustomerEducationAddUpdate);
